import { derived, writable } from 'svelte/store';
export const activeStyleId = writable(null);
export const nextStyleId = writable(null);
export const visibleStylesId = derived([activeStyleId, nextStyleId], styles => [...styles]);
